import { AppDispatch, RootState } from 'src/store/store';
import { Divider, Flex, HStack, Heading, Text, VStack, useDisclosure } from '@chakra-ui/react';
import { PROFILE_HEADINGS_ENG} from 'src/common/constants/englishLabels';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { GlobalUtils } from 'src/utils/globalUtils';
import { PROFILE_HEADINGS_HIN } from 'src/common/constants/hindiLabels';
import { ProfileDto } from 'src/types/Profile';
import RightAlignedDrawer from './rightAlignedModal';

interface AddressProps { userData: ProfileDto | null }

export const Address: React.FC<AddressProps> = ({ userData }) => {
  const globalInfo = useSelector((state: RootState) => state.globalInfo);
  const { globalLanguage } = globalInfo;
  const isHindiLabels = globalLanguage === 'HI';
  const dispatch = useDispatch<AppDispatch>();
  const { isOpen, onClose } = useDisclosure();
  const [localUser, setLocalUser] = useState<ProfileDto | null>(userData);

  useEffect(() => { GlobalUtils.setGlobalLanguage(dispatch); }, [dispatch]);
  useEffect(() => { setLocalUser(userData); }, [userData]);

  if (!localUser) return <Text>No address data available</Text>;

  const communication = localUser.communicationDetails;
  const current = communication.currentAddress || {
    addressLine1: communication.addressLine1 || null,
    addressLine2: communication.addressLine2 || null,
    villageCity: communication.city || null,
    state: null,
    postOffice: null,
    pincode: null,
  };
  const currentStreet = [current.addressLine1, current.addressLine2].filter(Boolean).join(', ');

  const permanent = communication.permanentAddress || {
    addressLine1: null,
    addressLine2: communication.addressLine2 || null,
    villageCity: communication.city || null,
    state: null,
    postOffice: null,
    pincode: null,
  };
  const permanentStreet = [permanent?.addressLine1, permanent?.addressLine2].filter(Boolean).join(', ');

  return (
    <Flex direction="column" width="100%">
      <VStack alignItems="flex-start" width="100%">
        <Flex direction="row" alignItems="center" justifyContent="space-between" width="100%">
          <HStack>
            <Heading fontSize="32px">{isHindiLabels ? PROFILE_HEADINGS_HIN.CURRENT_ADDRESS : PROFILE_HEADINGS_ENG.CURRENT_ADDRESS}</Heading>
          </HStack>
        </Flex>
        <Text>
          {currentStreet && (<>{currentStreet}<br /></>)}
          {current.villageCity && (<>{current.villageCity}, </>)}
          {current.state && (<>{current.state}<br /></>)}
          {current.postOffice && (<>{current.postOffice}<br /></>)}
          {current.pincode && (<>Pin - {current.pincode}</>)}
        </Text>
      </VStack>

      <Divider mt="1rem" height="1px" backgroundColor="rgba(108, 117, 125, 0.32)" />

      <VStack alignItems="flex-start" mt="1rem" width="100%">
        <Flex direction="row" alignItems="center" justifyContent="space-between" width="100%">
          <HStack>
            <Heading fontSize="32px">{isHindiLabels ? PROFILE_HEADINGS_HIN.PERMENANT_ADDRESS : PROFILE_HEADINGS_ENG.PERMENANT_ADDRESS}</Heading>
          </HStack>
        </Flex>
        <Text>
          {permanentStreet && (<>{permanentStreet}<br /></>)}
          {permanent?.villageCity && (<>{permanent.villageCity}, </>)}
          {permanent?.state && (<>{permanent.state}<br /></>)}
          {permanent?.postOffice && (<>{permanent.postOffice}<br /></>)}
          {permanent?.pincode && (<>Pin - {permanent.pincode}</>)}
        </Text>
      </VStack>

      <RightAlignedDrawer
        view={"ADDRESS"}
        isOpen={isOpen}
        onClose={onClose}
        userData={localUser}
        onSave={(updated) => { setLocalUser(updated); }}
      />
    </Flex>
  );
}

export default Address;